export default __webpack_public_path__ + "static/logo-12-f1228b282e7b8eefabd9f284180b428b.webp";